import {
	getOrder,
	postReconcileStatus,
} from '../../services/api/order.api';
import { transformOrderDetail } from '../../transforms/order';
import { transformError } from '../../transforms/error';
import {
	GET_ORDER_SINGLE_REQUEST,
	GET_ORDER_SINGLE_SUCCESS,
	GET_ORDER_SINGLE_FAILURE,
	POST_ORDER_RECONCILE_REQUEST,
	POST_ORDER_RECONCILE_SUCCESS,
	POST_ORDER_RECONCILE_FAILURE,
} from '../types';
import i18n from '../../plugins/i18n';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformOrderDetail({}),
	},

	mutations: {
		[GET_ORDER_SINGLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_ORDER_SINGLE_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformOrderDetail(data);
		},
		[GET_ORDER_SINGLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		[POST_ORDER_RECONCILE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[POST_ORDER_RECONCILE_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformOrderDetail(data);
		},
		[POST_ORDER_RECONCILE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		updateState(state, option = {}) {
			Object.keys(option).forEach((key) => {
				state[key] = option[key];
			});
		},
	},

	actions: {
		async getOrder({ commit }, { id }) {
			try {
				commit(GET_ORDER_SINGLE_REQUEST);
				const { data } = await getOrder(id);
				commit(GET_ORDER_SINGLE_SUCCESS, data);
			} catch (error) {
				commit(GET_ORDER_SINGLE_FAILURE, error);
				// show toast
				this.dispatch('toast/showToast', {
					header: i18n.t('toast.error'),
					content: i18n.t('toast.unexpectedError'),
					type: 'danger',
				});
			}
		},
		async updateOrderReconcileStatus({ commit }, id) {
			try {
				commit(POST_ORDER_RECONCILE_REQUEST);
				const { data } = await postReconcileStatus(id);
				commit(POST_ORDER_RECONCILE_SUCCESS, data);
			} catch (error) {
				commit(POST_ORDER_RECONCILE_FAILURE, error);
				// show toast
				this.dispatch('toast/showToast', {
					header: i18n.t('toast.error'),
					content: i18n.t('toast.unexpectedError'),
					type: 'danger',
				});
			}
		},
		updateState({ commit }, option = {}) {
			commit('updateState', option);
		},
	},
};
